import React from 'react';
import { connect } from 'react-redux';
import { PopUpBannerForm } from './PopUpBannerForm';
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class PopUpBannerDetail extends React.Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('pop_up_banner_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return(
      <div className="animate fadeIn">
        <PopUpBannerForm
          edit
          useCrop
          title="Pop Up Banner Details"
          {...this.props}
        />
      </div>
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, id, email } })=>({
  guardData: { isFetch, roles, isLogged, id, email }
})

const enhance = connect(mapStateToProps);

export default enhance(privateView(PopUpBannerDetail, ['supervisor', 'sale_supervisor', 'customer_service']));